import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';

export const PhaseHistoryEventTypeSchema = z.enum([
  'phase_change',
  'project_completed',
  'project_reactivated',
]);
export type PhaseHistoryEventType = z.infer<typeof PhaseHistoryEventTypeSchema>;

export const PhaseHistorySchema = z.object({
  history_id: UuidSchema,
  project_id: UuidSchema,
  from_phase_id: UuidSchema.nullable().optional(),
  to_phase_id: UuidSchema.nullable().optional(),
  event_type: PhaseHistoryEventTypeSchema.default('phase_change'),
  note: z.string().nullable().optional(),
  changed_at: IsoDateTimeSchema,
  changed_by: UuidSchema.nullable().optional(),
});
export type PhaseHistory = z.infer<typeof PhaseHistorySchema>;
